const content: { [key: string]: any } = {
  tabs: {
    performance: "Performance & Income",
    group: "Group Management",
  },
  monthly: "Monthly",
  annual: "Annual",
  toggle: "Show Data",
  performance: {
    title: "Performance",
    incomeTile: {
      title: {
        gpvNeeded: "GPV Needed to Reach {percent}%: <1>{amount}</1>",
        gpvNeededMobile: "GPV Needed to Reach",
        gpvNeededForLB: "GPV Needed for Max Leadership Bonus: <1>{amount}</1>",
        gpvNeededForLBMobile: "GPV Needed for Max Leadership Bonus:",
        gpvNeededForSP: "GPV Needed SP Month: <1>{amount}</1>",
        gpvNeededForSPMobile: "GPV Needed SP Month:",
        spQualified: "You're SP Qualified! Way to go!",
      },
      total: "Total GPV",
      bonusLevel: "Performance Bonus Level",
      progressTitle: {
        base: "Performance Bonus",
        single: "{level}% Performance Bonus",
        double: "{first} or {second}% Performance Bonus",
        range: "{first}-{last}% Performance Bonus",
      },
      qualifiedLegs: "Qualified Legs",
      legend: {
        bfi: "BFI GPV Target",
        bbi: "BBI GPV Target",
        sp: "SP Month",
        maximizeLeadership: "Maximize Leadership Bonus",
      },
      currentSop: "Current SOP PV",
      expectedSop: "Expected SOP PV",
      expectedSopAmount: "({amount})",
      showMore: "Show More",
      showLess: "Show Less",
    },
    leadershipSeminar: {
      manuallyApprovedMessage:
        "Congratulations! You have been manually approved for {title}. View {title} page for more details.",
      notEligibleMessage: "You are not currently eligible for {title}. View {title} page for more details.",
      onHoldMessage: "Approval for {title} is currently on hold. View {title} page for more details.",
      onHoldMessageMobile: "Approval for {incentiveName} is currently on hold.",
      currentYtd: "Current YTD",
      lsvTarget: "Target",
      lsvCurrent: "Current",
      lsvSuffix: "{value} LSV",
    },
    hatgar: {
      hatTileTitle: "HAT Legs Tracking",
      hatInMarket: "In-Market Legs",
      hatFoundersLegs: "Founders (Q12) Legs",
      hatTotalLegs: "Total Legs",
      awardLevelPY: "GAR Award Level PY{shortPY}",
      highestAwardLevel: "Highest Award Level",
      garAwardLevelPY: "Global Award Level PY{shortPY}",
      pinTrackingQualifiedLegsAward: "In-Market Pin Tracking Level",
      pinTrackingGlobalAwardRecognition: "Global Award Tracking Level",
      pinTrackingGlobalAwardRecognitionMobile: "GAR Tracking Level",
      pinTrackingFpStatus: "Founders Platinum Status",
      garTileTitle: "GAR Tracking",
      lastMonthProcessed: "Last Month Processed",
      foundersDiamondStatus: "F. Diamond Status",
      foundersPlatinumLegs: "F. Plat Legs",
      platinumLegs: "Plat Legs",
      totalLegsCounting: "Total Legs Counting Towards GAR",
      qualificationCredits: "Qualification Credits",
      qualificationCreditsMax: "Qualification Credits at max of {qcMax} per leg",
      qualificationCreditsMaxMobile: "QCs at max of {qcMax} per leg",
      qualCreditsNotCounting: "Qualification Credits Not Counting",
      qualCreditsNotCountingMobile: "QCs Not Counting",
      garInfoDownloadPrompt: "Have more questions? Download additional information below.",
      garInfoPanelTitle: "GAR Tracking Information",
      viewStatus: "View Status",
      annualIncentiveTracking: "Annual Incentive Tracking",
      foundersAchievementAwardTracking: "Founders Achievement Award Tracking",
      faaTracking: "FAA Tracking",
      dbrStatus: "DBR",
      fPlatLegs: "F. Plat Legs",
      faaPoints: "FAA Points",
      faaMultiplier: "FAA Multiplier",
      trackingBonus: "Tracking Bonus",
      superLegs: "Super Legs",
      trackingPinTitle: "Tracking Pin Information",
      annualIncentiveTrackingTitle: "Annual Incentive Tracking",
      trackingSubtitle: "Tracking",
      trackingBonusSubtitle: "Tracking Bonus",
      pqsLabel: "PQs",
      fqsLabel: "FQs",
      currentInMarketPin: "In-Market Pin Level PY{shortPY}",
      currentMonthProcessing: "Current Month Processing:",
    },
    inmarketpin: {
      tileTitle: "In-Market Award/Pin Information",
    },
    foundersPlatinumTile: {
      title: "Founders Platinum Status",
      description: "See how you're tracking for Founders Platinum!",
    },
  },
  income: {
    monthlyEstimatedIncome: "Current Estimated Monthly Income",
    annualEstimatedIncome: "Current Estimated Annual Income",
    earningsCalculator: {
      title: "Earnings Calculator",
      description: "Explore ways to increase your earning potential!",
      descriptionMaxThreshold: "Use the Earnings Calculator to help your downline increase their earning potential!",
    },
    mbi: {
      title: "My Business Income",
      description: "View your PY {performanceYear} Estimated Monthly Bonus History",
    },
    onlineStatements: {
      title: "Online Statements",
      description: "View and download PDFs for the past three fiscal years, including the current fiscal year.",
    },
  },
  legsProgress: {
    baseline: "Baseline",
    currentYTD: "Current YTD",
    tracking: "Tracking",
    current: "Current",
    pq: "{value} PQ",
    fq: "{value} FQ",
    qc: "{value} QC",
    fqBaseline: "FQ Baseline",
    fqTracking: "FQ Tracking",
    qcBaseline: "QC Baseline",
    qcCurrentYTD: "QC Current YTD",
    q: "{value} Q",
    qMonth: "{value} Q",
    qMonths: "{value} Q Months",
    q6Leg: "{value} Q6 Leg",
    q6Legs: "{value} Q6 Legs",
    q6LegsMobile: "Q6 Legs",
  },
  tagStatus: {
    onTrack: "On Track",
    achieved: "Achieved",
    notTracking: "Not Tracking",
    onHold: "On Hold",
    notEligible: "Not Eligible",
  },
  incentives: {
    incomeBreakdown: "Income Breakdown",
    corePlanBonuses: "Core Plan Bonuses",
    corePlusIncentives: "Core Plus+ Incentives",
    statusMessages: {
      held: "Your award is on hold. View {title} page for more details.",
      denied: "Your PY{perfYear} business is not eligible for the {title}. View {title} page for more details.",
      manuallyApproved: "The {title} has been manually approved. View {title} page for more details.",
      monthlyDenied: "You were not eligible for the {title} in {month} {year}. View {title} page for more details.",
    },
    comingSoon: {
      title: "Data Not Yet Available",
      message:
        "The tracking information for this incentive will be available after baseline calculations are complete.",
      naBonusAmount: "N/A",
    },
    ssi: {
      title: "Strong Start Incentive{symbol}",
      personalPv: "{Current}/{Target} PPV",
      member: "{Current}/{Target} PCPV",
      vcs: "{Current}/{Target} VCS PV",
      "ratioOfVcsToPpvPersonalOts(100%-OtsPercent(bonusAward552)": "{Current}/{Target} Monthly VCS of PPV",
    },
    bronzeIncentives: {
      ptb: {
        title: "Path To Bronze{symbol}",
      },
      bfi: {
        title: "Bronze Foundation{symbol}",
      },
      bbi: {
        title: "Bronze Builder{symbol}",
      },
      personalPpv: "{Current}/{Target} PPV",
      personalActivityPv: "{Current}/{Target} PAPV",
      legsAtPercentage: "{Target} Legs at {LegsTarget}",
      performanceBonusLevel: "{perfBonus} Performance Bonus Level",
      performanceBonusLevelTag: "Additional <strong>{neededGPV} {volumeType} needed</strong>",
      performanceBonusLevelTagMobile: "Additional {neededGPV} {volumeType} needed",
      vcsPercent: "{Current}/{Target} Monthly VCS of PPV",
      viewDownlineButton: "View Downline Information",
      vcsPV: "{Current}/{Target} VCS PV",
      verifiedCustomerPv: "{Current}/{Target} VCS PV",
      pcpv: "{Current}/{Target} PCPV",
      vcsBonusLegs: "Two {Target} Legs with {LegsTarget} VCS PV",
      papv: "{Current}/{Target} PAPV",
      newLegRequirements: "{Target} New Legs at {valueTarget} GPV",
      ppvLegs: "Minimum of {Target} New Legs at {valueTarget} PPV",
      gpvLegs: "Minimum of {Target} New Legs at {valueTarget} GPV",
    },
    monthlyQ: {
      title: "Monthly Q1/QV+",
      personal: "{Current}/{Target} PPV",
      basisCheckForSilverWithEq: "Qualified Silver Producer",
      monthlyGroupPv: "{Current}/{Target} GPV",
      monthlyGroupPvMobile: "{Current}/{Target} GPV <b> (QV) </b>",
      monthlyGroupPvWithQLeg: "{Current}/{Target} GPV",
      monthlyGroupPvWithQLegMobile: "{Current}/{Target} GPV <b> (Q1) </b>",
      q1Label: "(Q1)",
      qvLabel: "(QV)",
    },
    qGrowthIncentive: {
      title: "Q Growth Incentive+",
      monthlyGroupPv: "{Current}/{Target} GPV or {LegsTarget} GPV with 1 or more qualified legs",
      monthlyGroupPvMobile: "{Current}/{Target} GPV or {LegsTarget} GPV with {valueTarget} or more qualified legs",
      maintainGrowQMonths: "Maintain/Grow Q Months",
    },
    monthlyPgg: {
      title: "Monthly Personal Group Growth{symbol}",
      ruby: "{Current}/{Target} Ruby PV or {LegsTarget} with 1 or more qualified legs",
      groupPv: "{Current}/{Target} Group PV or {LegsTarget} with 1 or more qualified legs",
      "personalQMonth-Pgg": "Tracking for Annual Personal Group Growth Incentive+",
      currentAwardCheckForPlatinumWithGe: "Qualified Platinum Pin or Above",
      maintainRequirement: "Maintain Q Month Base",
    },
    performancePlus: {
      title: "Performance Plus{symbol}",
      groupPv: "{Current}/{Target} Group PV or {LegsTarget} with 1 or more qualified legs",
      personalPpv: "{Current}/{Target} PPV",
      maintainRequirement: "Maintain Q Month Base",
    },
    performanceElite: {
      title: "Performance Elite{symbol}",
    },
    performancePlusElite: {
      title: "Performance Plus and Elite{symbol}",
      titleMobile: "Performance Plus and\\nElite +",
    },
    ppe: {
      personalPpv: "{Current}/{Target} PPV",
      performancePlusRuby: "{Current}/{Target} Ruby PV Performance Plus",
      performanceEliteRuby: "{Current}/{Target} Ruby PV Performance Elite",
      basisCheckForSilverWithEq: "Qualified Silver Producer",
      "ratioOfVcsToPpvPersonalOts(100%-OtsPercent(bonusAward552)": "{Current}/{Target} Monthly VCS of PPV",
    },
    performance: {
      title: "Performance Bonus",
      personal: "Personal",
      differential: "Differential",
    },
    ruby: {
      title: "Ruby",
      value: "{Current}/{Target} RPV",
      rubyPv: "Ruby PV",
      rubyBv: "Ruby BV",
    },
    leadership: {
      title: "Leadership",
    },
    depth: {
      title: "Depth",
    },
    foster: {
      title: "Foster",
      leadershipRequirement: "{Current}/{Target} Leadership PV",
      leadershipPv: "Leadership PV",
      leadershipPercent: "Leadership %",
    },
    internationalLeadership: {
      title: "International Leadership",
    },
    csi: {
      title: "Customer Sales Incentive{symbol}",
    },
    pgg: {
      title: "Personal Group Growth{symbol}",
      rubyPVBoosterLabel: "Additional <1>{volumeNeeded} {volumeType} needed for Booster</1>",
      rubyPVBoosterLabelMobile: "Additional {volumeNeeded} {volumeType} needed for Booster",
      personal: "{current}/{target} Annual PPV",
      monthlyRuby: "{current}/{target} Ruby PV or {targetWithLeg} with 1 or more qualified legs",
      ruby: "{current}/{target} Annual Ruby PV",
      annualRuby: "{current}/{target} Annual Ruby PV",
      annualPersonal: "{current}/{target} Annual PPV",
      group: "{current}/{target} Group PV or {targetWithLeg} with 1 or more qualified legs",
      basisCheckForFoundersPlatinumWithEq: "Qualified Founders Platinum Pin",
      basisCheckForGoldWithEq: "Qualified Gold Producer",
      basisCheckForFoundersPlatinumWithEqAna: "Qualified Founders Platinum Pin with 6 Q Legs",
      basisCheckForPlatinumWithEq: "Qualified Platinum Pin or Above",
      ytdVcsPercentageCheckForPersonalGroupGrowth: "{current}/{target} Annual VCS of PPV",
      "ytdVcsPercentageCheckForpersonalGroupGrowth(955)": "{current}/{target} Annual VCS of PPV",
      ytdVcsPercentageCheckForpersonalGroupTieredIncentive: "{current}/{target} Annual VCS of PPV",
      growthOrMaintainCheckForplatinum: "Maintain Pin",
      maintainGrowPQs: "Maintain/Grow PQs",
      leadershipAndFoster: "Minimum Annual Leadership Bonus of {bonusAmount}",
      annualPggTracking: "Tracking for Annual Personal group Growth+",
      annualPggiTracking: "Tracking for Annual Personal Group Growth+",
      basisCheckForFoundersPlatinumWithGe: "Qualified Founders Platinum Pin or Above",
      maintainMinimumSingle: "Maintain / Minimum of 1 PQ",
      maintainMinimumMulti: "Maintain / Minimum of {minPQs} PQs",
    },
    pggGcr: {
      title: "Personal Group Growth Incentive{symbol}",
    },
    personalGrowthAnnual: {
      title: "Annual Personal Group Growth{symbol}",
    },
    // ANA markets (US/CA/DO) call this incentive "Personal Group Growth Incentive" on the
    // detail page (annualPGG/monthlyPGG pageTitle overrides) — these keys mirror pgg/monthlyPgg/
    // personalGrowthAnnual's titles with "Incentive" added, selected for ANA markets only in
    // useIncomeBreakdownTiles.ts and MonthlyIncomeBreakdownMapper.tsx.
    pggIncentive: {
      title: "Personal Group Growth Incentive{symbol}",
    },
    monthlyPggIncentive: {
      title: "Monthly Personal Group Growth Incentive{symbol}",
    },
    personalGrowthAnnualIncentive: {
      title: "Annual Personal Group Growth Incentive{symbol}",
    },
    fgi: {
      title: "Frontline Growth Incentive{symbol}",
      personal: "{current}/{target} Annual PPV",
      personalActivityPv: "{current}/{target} Annual PAPV",
      ruby: "{current}/{target} Annual Ruby PV",
      basisCheckForFoundersPlatinumWithEq: "Qualified Founders Platinum Pin",
      basisCheckForPlatinumWithEq: "Qualified Platinum Pin or Above",
      ytdVcsPercentageCheckForfrontlineGrowthIncentive: "{current}/{target} Annual VCS of PPV",
      growthOrMaintainCheckForsilver: "Maintain Pin",
      leadershipAndFoster: "Minimum Annual Leadership Bonus of {bonusAmount}",
      maintainGrowFQs: "Maintain/Grow FQs",
      basisCheckForFoundersPlatinumWithGe: "Qualified Founders Platinum Pin or Above",
    },
    leadershipPlus: {
      title: "Leadership Plus+",
    },
    annualQ: {
      title: "Annual Q+",
      annualPpv: "{current}/{target} Annual PPV",
      currentProgress: "{current}/{target}",
      monthlyPPVTracker: "{current}/{target} Monthly PPV Tracker (Through {month})",
      qualifiedPlatinumPin: "Qualified Platinum Pin or Above",
    },
    frontlineQ: {
      title: "Frontline Q+",
      foundersPlatinum: "Qualified Founder's Platinum Pin or Above",
      inMarketFrontlineQ: "1 In-Market Frontline Q",
      previousPYModal: "Previous Performance Year",
      currentPYModal: "Current YTD",
      annualPpv: "{current}/{target} Annual PPV",
    },
    visionBonus: {
      title: "Vision Bonus+",
      maintainPin: "Maintain Core Award",
      fqOrQcGrowth: "FQ or QC Growth",
      maintainGARAward: "Maintain GAR Award",
      QualifiedDiamondBonusRecipient: "Qualified Diamond Bonus Recipient",
      inMarketFoundersEmeraldAward: "In-Market Founder's Emerald Award",
      maintainCoreAward: "Maintain Core Award",
      qualifiedDiamondBonusRecipient: "Qualified Diamond Bonus Recipient",
      inMarketFounderEmeraldAward: "In-Market Founder's Emerald Award",
    },
    qcGrowth: {
      title: "QC Growth Incentive+",
      diamondBonus: "Qualified Diamond Bonus Recipient",
      maintainGar: "Maintain GAR Award",
      maintainQc: "Maintain/Increase QCs",
      executiveDiamondBonus: "Qualified Executive Diamond and Above",
    },
    ttca: {
      title: "Two Time Cash Award",
      executiveDiamond: "Executive Diamond",
      foundersExecutiveDiamond: "Founders Executive Diamond",
      doubleDiamond: "Double Diamond",
      foundersDoubleDiamond: "Founders Double Diamond",
      tripleDiamond: "Triple Diamond",
      foundersTripleDiamond: "Founders Triple Diamond",
      crown: "Crown",
      foundersCrown: "Founders Crown",
      crownAmbassador: "Crown Ambassador",
      foundersCrownAmbassador: "Founders Crown Ambassador",
    },
    cci: {
      title: "Comeback Cash Incentive+",
      platinum: "Platinum",
      foundersPlatinum: "Founders Platinum",
      sapphire: "Sapphire",
      foundersSapphire: "Founders Sapphire",
      emerald: "Emerald",
      foundersEmerald: "Founders Emerald",
      diamond: "Diamond",
      foundersDiamond: "Founders Diamond",
    },
    ttci: {
      title: "Two Time Cash Incentive{symbol}",
      ppvTile: "{current}/{target} PPV Monthly Average",
      vcsTile: "{current}/{target}% Cumulative VCS",
      silver: "Silver",
      gold: "Gold Producer",
      platinum: "Platinum",
      foundersPlatinum: "Founders Platinum",
      sapphire: "Sapphire",
      foundersSapphire: "Founders Sapphire",
      emerald: "Emerald",
      foundersEmerald: "Founders Emerald",
      diamond: "Diamond",
      foundersDiamond: "Founders Diamond",
      a70Emerald: "A70 Emerald",
      a70FoundersEmerald: "A70 Founders Emerald",
      a70Diamond: "A70 Diamond",
      a70FoundersDiamond: "A70 Founders Diamond",
    },
    otci: {
      title: "One Time Cash Incentive+",
      gold: "Gold Producer",
      platinum: "Platinum",
      emerald: "Emerald",
      diamond: "Diamond",
    },
    foundersAchievment: {
      title: "Founder's Achievement Award",
    },
    pathToA70: {
      title: "Path to A70+",
    },
    diamondA70: {
      title: "A70 100+ Diamond Bonus+",
      basisCheckForEmeraldWithGe: "Qualified Emerald Pin or Above",
      basisCheckForSapphireWithGe: "Qualified Sapphire Pin or Above",
      growthOrMaintainCheckForemerald: "Maintain Pin",
      growthOrMaintainCheckForsapphire: "Maintain Pin",
      inmarketQ6LegGrowth: "Add {target} In-Market Q6 Leg",
      qCountPerformance: "Grow {current}/{target} FQ",
    },
    a70EliteBonus: {
      title: "A70 Elite Bonus+",
    },
    healthAndWellbeing: {
      title: "Health and Wellbeing Bonus+",
      personal: "{current}/{target} Annual PPV",
      ruby: "{current}/{target} Annual Ruby PV",
      basisCheckForFoundersPlatinumWithGe: "Qualified Founders Platinum Pin or Above",
      basisCheckForFoundersPlatinumWithEq: "Qualified Founders Platinum Pin",
      growthPqFq: "Grow 12+ Combined PQs and FQs Compared to PY{perfYear}",
      denied: "You are not eligible for the Health and Wellbeing Bonus+.",
    },
    fsi: {
      title: "Founders Sales Incentive{symbol}",
      personalPpv: "{Current}/{Target} PPV",
      vcsPercent: "{Current}/{Target} Monthly VCS of PPV",
      held: "Your Founders Sales Incentive{symbol} award is on hold. View Founders Sales Incentive page for more details.",
      denied: "You are not eligible for the Founders Sales Incentive{symbol}.",
      manuallyApproved: "The Founders Sales Incentive{symbol} has been manually approved.",
    },
    faa: {
      title: "FAA",
    },
    emeraldBonus: {
      title: "Emerald Bonus*",
    },
    diamondBonus: {
      title: "Diamond Bonus*",
    },
    diamondPlusBonus: {
      title: "Diamond Plus Bonus*",
    },
    a70Ttca: {
      title: "A70 Two Time Cash Award+",
      executiveDiamond: "Executive Diamond",
      foundersExecutiveDiamond: "Founders Executive Diamond",
      doubleDiamond: "Double Diamond",
      foundersDoubleDiamond: "Founders Double Diamond",
      tripleDiamond: "Triple Diamond",
      foundersTripleDiamond: "Founders Triple Diamond",
      crown: "Crown",
      foundersCrown: "Founders Crown",
      crownAmbassador: "Crown Ambassador",
      foundersCrownAmbassador: "Founders Crown Ambassador",
    },
  },
  performanceBonusSchedule: "Performance Bonus Schedule",
  personal: {
    title: "Personal Bonus",
    description:
      "Your personal bonus is the total earnings from your purchases as well as from your customers and members.",
    personalBV: "Personal BV",
    performanceBonusTitle: "Performance Bonus",
    performanceBonus: "x {bonus}%",
    personalTotal: "Current Personal Total",
  },
  differential: {
    title: "Differential Bonus",
    description:
      "Your Differential Multiplier is the <1>difference between your performance bonus level and your frontline’s performance bonus level.</1>",
    performanceBonus: "{percent}% Performance Bonus",
    gpv: "{amount} GPV",
    groupBV: "Group BV",
    groupBVMobile: "Group BV ({countryCode})",
    multiplierTitle: "Differential Multiplier ({percent1}%-{percent2}%)",
    multiplierTitleMobile: "Differential Multiplier",
    multiplier: "x {percent}%",
    multiplierMobile: "x",
    currentDifferentialTotal: "Current Differential Total",
    differentialTotal: "Differential Bonus Total",
    export: "Export",
  },
  corePlanBonusesDisclaimer: "*These bonuses will not be calculated until the Performance Year has closed",
  expandBonusScale: "Expand bonus scale",
  collapseBonusScale: "Collapse bonus scale",
};

export default content;
